import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, rupee } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirm() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then((r) => setO(r.data)); }, [id]);
  if (!o) return <div className="p-20 text-center">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 text-center fade-up">
      <CheckCircle2 className="mx-auto text-[#C5A059]" size={56} />
      <p className="eyebrow mt-6">Thank you</p>
      <h1 className="font-serif text-4xl md:text-5xl mt-3">Order Confirmed</h1>
      <p className="mt-4 text-[#55524D]">Your order <span className="font-mono">{o.order_id}</span> has been placed.</p>
      {o.status === "awaiting_payment" && (
        <p className="mt-3 text-sm text-[#5B1C22]" data-testid="order-awaiting-payment">Payment under verification — your order will be confirmed once your UPI payment to <span className="font-mono">sarbjsarbjkaur@oksbi</span> is verified.</p>
      )}
      <div className="border border-[#E2DDD5] p-6 mt-10 text-left space-y-2 text-sm">
        <div className="flex justify-between"><span>Total Paid</span><span className="font-medium">{rupee(o.total)}</span></div>
        <div className="flex justify-between"><span>Payment Method</span><span className="uppercase">{o.payment_method}</span></div>
        <div className="flex justify-between"><span>Status</span><span className="text-[#C5A059] uppercase tracking-widest">{o.status}</span></div>
      </div>
      <p className="mt-8 text-xs text-[#8C867D]">A unique LEE BAG QR authenticity certificate has been generated for each piece. View them in <Link to="/account" className="underline">My Account</Link>.</p>
      <Link to="/" className="btn-lux mt-8 inline-flex">Continue Shopping</Link>
    </div>
  );
}
